import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/permission'
import '@/styles/index.scss'
// svg
import '@/icons/index'
import './styles/element-variables.scss'
import {
	Row,
	Col,
	// Row,
	// Col,
	Switch,
	Button,
	ButtonGroup,
	Select,
	Option,
	Icon,
	Input,
	InputNumber,
	Dialog,
	Upload,
	Radio,
	RadioGroup,
	Pagination,
	Loading,
	Message,
	MessageBox,
	Tabs,
	Tag,
	TabPane,
	Table,
	TableColumn,
	Checkbox,
	CheckboxGroup,
	// CheckboxButton,
	// Form,
	// Tabs,
	Popover,
	Tooltip,
	Form,
	FormItem,
	DatePicker,
	Timeline,
	TimelineItem
	// TimePicker
} from 'element-ui'
Vue.use(Row)
Vue.use(Col)
Vue.use(ButtonGroup)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Tag)
// Vue.use(CheckboxButton)
// Vue.use(Row)
// Vue.use(Col)
Vue.use(Button)
Vue.use(Select)
Vue.use(Option)
Vue.use(Icon)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Dialog)
Vue.use(Upload)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Pagination)
Vue.use(Tabs)
Vue.use(Table)
Vue.use(TableColumn)
// Vue.use(Form)

// Vue.use(Tabs)
Vue.use(Popover)
Vue.use(Tooltip)
Vue.use(Form)
Vue.use(Switch)
Vue.use(FormItem)
Vue.use(TabPane)
Vue.use(DatePicker)
Vue.use(TimelineItem)
Vue.use(Timeline)
// Vue.use(TimePicker)
Vue.use(Loading.directive)
Vue.use(ElementUI)
Vue.use(Loading.directive)
Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$message = Message

import components from '@/components/component.js'
Vue.use(components)

import dialog from '@/components/dialog/index'
Vue.use(ElementUI)
Vue.component('jdialog', dialog)

Vue.config.productionTip = false
import '@/utils/filter'
new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
